import {Backdrop, BackdropProps, CircularProgress} from "@mui/material";
import theme from "../theme";
import React from "react";

export const PaperBackdrop: React.FC<BackdropProps> = ({open, children}) => {
    return (
        <div style={{height: "100%"}}>
            <Backdrop sx={{color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1, position: "absolute", backgroundColor: "white", borderRadius: `${theme.shape.borderRadius * 5}px ! important`}} open={open}>
                {open && <CircularProgress style={{color: "rgb(0, 41, 44)"}}/>}
            </Backdrop>
            <div style={{paddingLeft: "30px", paddingRight: "30px", minHeight: "50px", maxHeight: open ? "80vh" : "initial", overflow: "hidden"}}>
                {children}
            </div>
        </div>
    );
}

